import { render, staticRenderFns } from "./InvitationHandler.vue?vue&type=template&id=6e918950&scoped=true"
import script from "./InvitationHandler.vue?vue&type=script&lang=js"
export * from "./InvitationHandler.vue?vue&type=script&lang=js"
import style0 from "./InvitationHandler.vue?vue&type=style&index=0&id=6e918950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e918950",
  null
  
)

export default component.exports